export default "__VITE_ASSET__BWcshKK8__"